<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="atlas">unoff</h2>
        <p>
          Content to be added.
        </p>


        <RasterMap 
          backgrounds="streets,satellite,light,osm" 
          title="Atlas" 
          attribution="Map: Geofolio. Data: Copernicus DEM [3] and ESA WorldCover [10]. Backgrounds: Mapbox/Openstreetmap Contributors [2]." 
          v-bind:layout="{legendWidth:5, legendCols:2, descriptionWidth:7, order:['legend','description'] }"
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          v-bind:layers="layers">
        </RasterMap>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */

    import _ from 'lodash';
    
    import RasterMap from '@/components/factsheet/RasterMap.vue'
    export default {
        name: 'Runoff',
        components: { RasterMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
          return {
            'layers': [
              {
                'title': 'Actual ET (Annual)', 
                'source': '/fao_wapor/L2-AETI-A-COMP.tif', 
                'long_description': "<p>Actual ET</p>"
              }
            ]
          }
        },
        created() {
          if(this.factsheet["info"]["location"]["country"] == 'ci') {
            this.layers.push({'title': 'Land Cover (IMAGES, 2019)', 'source': '/images_forest_alerts/rsac_land_use.tif'});
            this.layers.push({'title': 'Cocoa Probability (ETH, 2020)', 'source': '/eth_cocoa_maps/cocoa_probability.tif'});
          }
          if(this.factsheet.data["land_degradation_neutrality"]) {
            this.layers.push({'title': 'LDN Scores (2000-2020)', 'source': '/land_degradation_neutrality/ldn_score_2020.tif'});
          }
          if(this.factsheet.data["cafi_land_cover"]) {
            if(this.factsheet.data["cafi_land_cover"]["validated_extent"]) {
              this.layers.push({'title': 'CAFI Land Cover (2015)', 'source': '/cafi_land_cover/landcover.tif'});
              this.layers.push({'title': 'CAFI Forest Fragmentation (2015)', 'source': '/cafi_land_cover/forest_fragmentation.tif'});
              this.layers.push({'title': 'CAFI Burned Area (2016-2022)', 'source': '/cafi_land_cover/cafi_burned_area_2016_2022.tif'});
            }
          }
          if(this.factsheet.info.attachments.length > 0) {
            for(var n = 0; n<this.factsheet.info.attachments.length; n++) {
              var at = this.factsheet.info.attachments[n]
              if(at["category"] == 'atlas') {
                var lyr = {'title': at["name"], 'source': "/attachments/"+at["id"]+"/"+at["filename"], 'type':'attachment'}
                //this.layers.push(lyr)
              }
            }
          }
          if(this.factsheet.info.config.atlas_layers.length > 0) {
            this.layers.push(...this.factsheet.info.config.atlas_layers)
          }

        },
        computed: {
        },
        mounted() {

        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>